"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialStateModal = void 0;
// fast fix
var isHidden = true;
exports.initialStateModal = {
    modals: {
        burgerMenu: {
            modalState: false,
            menuNavigation: __spreadArray(__spreadArray([], (isHidden ? [] : [{ name: 'Каталог', link: '/catalog' }]), true), [
                {
                    name: 'В наличии',
                    link: '/cars',
                },
                {
                    name: 'Автокредит',
                    link: '/credit',
                },
                {
                    name: 'Рассрочка',
                    link: '/installment',
                },
                {
                    name: 'Выкуп',
                    link: '/buyout',
                },
                {
                    name: 'Trade-In',
                    link: '/exchange',
                },
                {
                    name: 'Банки',
                    link: '/banks',
                },
                {
                    name: 'Контакты',
                    link: '/contacts',
                },
                {
                    name: 'О компании',
                    link: '/about',
                },
            ], false),
        },
        promotion: {
            description: '',
            link: '',
            modalState: false,
            title: '',
        },
        callback: {
            modalState: false,
        },
        catalogOrder: {
            modalState: false,
            orderType: 'none',
        },
        credit: {
            modalState: false,
        },
        exchange: {
            modalState: false,
        },
        report: {
            modalState: false,
        },
        equipment: {
            modalState: false,
        },
        selectCar: {
            modalState: false,
            stateLoad: {
                isLoad: false,
                error: false,
            },
            filter: {
                brand: {
                    nextValue: null,
                    thisValue: null,
                    status: true,
                    selected: '',
                },
                model: {
                    nextValue: null,
                    thisValue: null,
                    status: false,
                    selected: '',
                },
                generation: {
                    nextValue: null,
                    thisValue: null,
                    status: false,
                    selected: '',
                },
                car: {
                    carSelect: {},
                    carList: [],
                    status: false,
                },
                stage: 1,
            },
        },
    },
};
